import { useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Table } from 'antd';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import Tab2 from './ta1';
import { useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'

import { Crypter } from "../../../../Functions/Security/Crypter";
//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMbloquer";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import InputForm from "../../../InputT";
import axios from "axios";
import SearInputG from "../../../SearchInput"
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import SearInputModal from "../../../SearchModal"


const AnnulBlocage = () => {

    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [form] = Form.useForm();
    const authHeader = useAuthHeader()
    const [state, setstate] = useState(false)
    const [Nummm, setNumm] = useState<number>(0)
    // Handle pour Gestion de Usestate
    const [Affiche, setAffiche] = useState(false);
    const [Annul, setAnnul] = useState(true);
    const [Actual, setActual] = useState(true);
    const [Actual2, setActual2] = useState(false);

    // function HandleAffiche() {
    //     setNumm(0);
    //     Consultableau();
    // }

    function HandleAnnul() {
        form.resetFields();
        setAffiche(false);
        setSelectedRowKeys([]);
        setData([]);
        setActual2(true)
        setAnnul(true);
        setActual(true);
    }

    function saver() {
        setAffiche(true)
    }

    function HandleActualiser() {
        Consultableau()
        setSelectedRowKeys([]);
        setAnnul(true);
        setActual(true);
        setActual2(false);
    }




    //state pour la recherche
    const [SearchR, SetSearchR] = useState<string>("");
    // usestate pour recuperer les données du tableau  
    const [donnees, setData] = useState<DataType[]>([]);

    // Gestion des Items 
    const items: TabsProps['items'] = [

        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Annulation Montant Bloquer
                </span>
            ),
            children: <Tab2 form={form} />, //form={form}
        },

    ];

    //column du tableau 
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro dossier',
            dataIndex: 'REFMARQ',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.REFMARQ)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.NUMCPT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.NOMCPT)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Numéro compte',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'Intitulé ',
            dataIndex: 'NOMCPT',
        },
        {
            title: 'Montant',
            dataIndex: 'MONTPR',
        },
        {
            title: 'Crée le',
            dataIndex: 'DATCRE',
        },
        {
            title: 'Date fin ',
            dataIndex: 'DATEFM',
        }
    ];


    ///function pour remplir les données du tableau 
    function Consultableau() {
        saver();
        let a = Perss.codage;
        let b = '2'
        let c = form.getFieldValue("NUMCLI")
        if (!loading) {
            setLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AllReadMontantBloquer2,
                headers: {
                    'Cyphercodage': Crypter.encrypt(a),
                    'Cyphertrie': Crypter.encrypt(b),
                    'CypherNumcli': Crypter.encrypt(c),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json',
                },
            };

            //MAPPING DANS LE TABLEAU
            let dat: DataType[] = [];

            axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {
                        let datas = response.data.Result;
                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                REFMARQ: val.REFMARQ,
                                codage: val.codage,
                                NUMCPT: val.NUMCPT,
                                NOMCPT: val.NOMCPT,
                                MONTPR: val.MONTPR,
                                DISPON: val.DISPON,
                                DATCRE: val.DATCRE,
                                DATEFM: val.DATEFM,
                                 MOTIFM: val.MOTIFM,
                            })
                        })
                        setData((dat))

                        //setTimeout<[]>

                    } else {
                        SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                });
        }
    }




    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))

        setAnnul(false)
        setActual(false)
        setActual2(false)

        //consult();
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };


    //function pour lire loadData

    // setTimeout(() => {
    //     if (donnees.length == 0) {
    //         if (!state) {
    //             setstate(true)
    //             Consultableau()
    //         }
    //         setNumm(1);
    //     }
    //     try {
    //         let reset = localStorage.getItem(Data.LocalVariable.reset)
    //         if (reset == "1") {
    //             setData([])
    //         }
    //     }
    //     catch (error) {
    //         console.log(error)
    //     }
    // }, 0.1);


    // function Onfinish
    const onFinish = () => {
        let Numcrd = (Crypter.decrypt(sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "";
        let data4 = Crypter.encrypt(Perss.codage);

        if (Numcrd == null) {
            SweetAlert.fire({ title: "Warning", text: "Svp selectionné un Gel", icon: "warning" })
        } else {
            SweetAlert.fire({
                title: "Annuler GEL",
                text: "Voulez-vous Annuler le Gel " + Numcrd + " ?",
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.AnnulMontantBloquer,
                        headers: {
                            'CypherREFMARQ': Crypter.encrypt((Numcrd)),
                            'Cypherutilis': Crypter.encrypt(Perss.coduti),
                            'Cyphercodeage':data4,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res);
                                let code = res.Message
                                if (code == 'GelInvalid') {
                                    SweetAlert.fire({ title: " ", text: "Gel déja Invalid", icon: "warning" })
                                } else if (code == 'ErrorUser2') {
                                    SweetAlert.fire({ title: " ", text: "Opération Impossible: l'utilisateur qui annule le Gel doit être diffirent du valideur", icon: "warning" })
                                } else if (code == 'ChangeUser') {
                                    SweetAlert.fire({ title: " ", text: "Opération Impossible: l'utilisateur qui annule ne peut être celui qui a initié", icon: "warning" })
                                } else {
                                    setIsSubmit(false)
                                    SweetAlert.fire({ title: " ", text: "Annulation du montant bloqué effectuée avec succes: reference " + code + " Annulé ", icon: "success" })
                                    localStorage.clear();
                                    Consultableau()
                                    setActual2(false)
                                    setAnnul(true)
                                    setActual(true)
                                    setSelectedRowKeys([])
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                        });
                }
            })
        }
    };

    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    let searchClient2: ParamsPicklist = { CodeAgence: Perss.codage, Table: "PROVISION", Colonne1: "NUMCLI", Colonne2: "NOMCPT", Colagence: 'codage', colfiltre: "", valfiltre: '', Choix: 22 }



    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> {window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* <Button size='large' className='bt_add' disabled={false} onClick={() => { HandleAffiche() }} type="ghost" htmlType="button" block  >
                                    Afficher
                                </Button> */}
                                <Button size='large' className='bt_add' disabled={Annul} onClick={() => { }} type="ghost" htmlType="submit" block  >
                                    Invalider
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actual} onClick={() => { HandleActualiser(); }} type="ghost" block>
                                    Actualiser
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { HandleAnnul(); }} type="ghost" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>

                            <div className='tabItem' >

                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >
                                        <Box fontStyle="inherit" className='border-left '>
                                            <legend> Listes des montants bloqués Valides  </legend>

                                            <Box className='border' style={{ display: 'flex', width: '100%'}} sx={{ mb: 2 }}>
                                                <Box style={{ width: '100%' }}>
                                                    <SearInputModal width={0} disabled={Affiche} Titre=" Recherche" label={'ID Client'} ExecuteafterSelect1={Consultableau} name="NUMCLI" Taille1={'100%'} Taille2={'150%'} Parametre={searchClient2} /* etat={setSearchGlobal} */ form={form} />
                                                </Box>
                                               
                                            </Box>
                                             <Box className='border' style={{ width: '100%'}} sx={{ mb: 2 }}>
                                                    <InputForm disabled={false} width={0} notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} name="Element" type="string" />
                                                </Box>

                                             <Box className='border'  style={{ width: '100%' }}>
                                                <Spin spinning={loading}>
                                                 <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} columns={columns} style={{ textAlign: "center", width: '100%', marginTop: -8 }} scroll={{ y: 400, x: 400 }} size='small' pagination={false} />
                                                 </Spin>
                                             </Box>
                                            
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );


}

export default AnnulBlocage;